import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'us-west-2_e1GlVP02b',
  ClientId: '4tf5qqvim06r8fo2dki08r7cei'        
};

export default new CognitoUserPool(poolData);